const Main = {
	target: process.env.NODE_ENV !== 'production' ? 'http://taohaome.test/api/' :
	'https://api.taohaome.com/api/', //'https://api-cms.hpcme.cn/cme/v.1/', //127.0.0.1:9090
	constant: {
		cookie: 'VUE_ELEMENT'
	},
	nav: {
		paths: [],
		treeList: [],
	},
	route: {
		index: '/',
		error404: '/404',
		error403: '/403',
		error500: '/500'
	}
}

export default Main



// WEBPACK FOOTER //
// ./src/config/index.js